// import React, { useState,useEffect } from 'react';
// import {
//   Box,
//   Text,
//   Button,
// } from "@chakra-ui/react";
// import { theme } from "../../styles/theme";


// export function AgeVerification() {
//   const [showAgeVerification, setShowAgeVerification] = useState(true);

//   useEffect(() => {
//     const showPopupFunction = () => {
//       setShowAgeVerification(true);
//       localStorage.setItem('lastVerifiedAge', new Date().getTime());
//       const hasConfirmedAge = localStorage.getItem('hasConfirmedAge');

//       if (hasConfirmedAge === 'true') {
//         setShowAgeVerification(false); // Don't show the popup if the user has already confirmed their age
//       }
//     };

//     showPopupFunction();

//     const popupInterval = setInterval(() => {
//       showPopupFunction();
//       localStorage.setItem('hasConfirmedAge', 'false');
//     }, 60 * 60 * 1000);

//     return () => {
//       clearInterval(popupInterval);
//     };
//   }, []);



//   const handleYesClick = () => {
//     localStorage.setItem('hasConfirmedAge', 'true');
//     setShowAgeVerification(false);
//   }

//   const handleNoClick = () => {
//     window.location.href = "https://www.itambe.com.br/";
//   }


//   return (
//     <>
//       {showAgeVerification && (
//         <Box zIndex='10000'>
//           <Box
//             className='bg-static'
//             position={"fixed"}
//             top={"0"}
//             left={"0"}
//             zIndex={"9998"}
//             width={"100vw"}
//             height={"100%"}
//             background={"rgba(0, 0, 0, 0.7)"}
//             over='true'
//           ></Box>
//           <Box
//             className='age-verification-popup'
//             width={{ base: '90%', md: '30%' }}
//             position={"fixed"}
//             top={{ base: '40%', md: '45%' }}
//             left={{ base: '5%', md: '35%' }}
//             zIndex={"9999"}
//             background={theme.colors.gray}
//             borderRadius="20px"
//             height={"13rem"}
//             padding={"10px"}
//           >
//             <Text
//               textAlign={"center"}
//               fontSize={"28px"}
//               margin={"5%"}
//               fontWeight={"bolder"}
//             >
//               Você tem mais de 18 anos?
//             </Text>
//             <Box
//               display={"flex"}
//               gap={"10px"}
//               justifyContent={"center"}
//             >
//               <Button
//                 background={theme.colors.primaryGreen}
//                 padding={"15px"}
//                 height={"25px"}
//                 borderColor={theme.colors.primaryGreen}
//                 width={"25%"}
//                 borderRadius="20px"
//                 border={`1px solid ${theme.colors.primaryGreen}`}
//                 color={theme.colors.primaryOrange}
//                 _hover={{
//                   background: "transparent",
//                   color: `${theme.colors.primaryGreen}`,
//                   border: `1px solid ${theme.colors.primaryGreen}`

//                 }}
//                 onClick={handleYesClick}
//               >
//                 SIM
//               </Button>
//               <Button
//                 background={"red"}
//                 padding={"15px"}
//                 height={"25px"}
//                 width={"25%"}
//                 borderRadius="20px"
//                 border={"1px solid red"}
//                 color={theme.colors.gray}
//                 _hover={{
//                   background: "transparent",
//                   color: "red",
//                 }}
//                 onClick={handleNoClick}
//               >
//                 NÃO
//               </Button>
//             </Box>
//           </Box>
//         </Box>
//       )}

//     </>
//   );
// }


import React, { useState, useEffect } from 'react';
import logoOrangeGreen from "../../assets/images/logo-white-orange.webp";
import {
  Box,
  Image,
} from "@chakra-ui/react";

const GREEN  = "#004a33";
const ORANGE = "#fc8f04";
const CREAM  = "#FDFAF6";

export function AgeVerification() {
  const [showAgeVerification, setShowAgeVerification] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const INTERVAL_HOURS = 24; // ← ajuste aqui: horas entre cada exibição
    const INTERVAL_MS    = INTERVAL_HOURS * 60 * 60 * 1000;

    function shouldShow() {
      const confirmed    = localStorage.getItem('hasConfirmedAge') === 'true';
      const lastVerified = parseInt(localStorage.getItem('lastVerifiedAge') || '0', 10);
      const elapsed      = Date.now() - lastVerified;

      // Mostra se nunca confirmou, ou se o intervalo expirou
      if (!confirmed || elapsed >= INTERVAL_MS) {
        localStorage.setItem('hasConfirmedAge', 'false');
        return true;
      }
      return false;
    }

    if (shouldShow()) {
      setShowAgeVerification(true);
      // pequeno delay para o fade-in funcionar
      requestAnimationFrame(() => requestAnimationFrame(() => setVisible(true)));
    }

    // re-verifica a cada intervalo
    const interval = setInterval(() => {
      if (shouldShow()) {
        setShowAgeVerification(true);
        requestAnimationFrame(() => requestAnimationFrame(() => setVisible(true)));
      }
    }, INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  const handleYesClick = () => {
    localStorage.setItem('hasConfirmedAge', 'true');
    localStorage.setItem('lastVerifiedAge', String(Date.now()));
    setVisible(false);
    setTimeout(() => setShowAgeVerification(false), 320);
  };

  const handleNoClick = () => {
    window.location.href = "https://www.itambe.com.br/";
  };

  if (!showAgeVerification) return null;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600;700;900&display=swap');

        .bz-age-overlay {
          position: fixed; inset: 0; z-index: 99998;
          background: rgba(10, 18, 8, 0.82);
          backdrop-filter: blur(6px);
          opacity: 0; transition: opacity 0.32s ease;
        }
        .bz-age-overlay.visible { opacity: 1; }

        .bz-age-card {
          position: fixed;
          top: 50%; left: 50%;
          transform: translate(-50%, calc(-50% + 24px)) scale(0.96);
          z-index: 99999;
          width: min(420px, 90vw);
          background: ${CREAM};
          border-radius: 24px;
          overflow: hidden;
          opacity: 0;
          transition: opacity 0.32s ease, transform 0.32s cubic-bezier(0.23, 1, 0.32, 1);
          font-family: 'DM Sans', sans-serif;
        }
        .bz-age-card.visible {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
        }

        .bz-age-banner {
          background: ${GREEN};
          padding: 28px 28px 20px;
          display: flex; flex-direction: column; align-items: center; gap: 10px;
        }
        .bz-age-logo {
          font-size: 28px; font-weight: 900;
          color: ${ORANGE}; letter-spacing: -0.04em;
          margin-bottom: 2px;
        }
        .bz-age-icon {
          width: 52px; height: 52px; border-radius: 50%;
          background: rgba(212, 65, 32, 0.15);
          display: flex; align-items: center; justify-content: center;
          font-size: 26px;
        }

        .bz-age-body {
          padding: 24px 28px 28px;
          display: flex; flex-direction: column; align-items: center; gap: 6px;
          text-align: center;
        }
        .bz-age-title {
          font-size: 20px; font-weight: 900; color: ${GREEN};
          letter-spacing: -0.03em; line-height: 1.2;
          margin: 0 0 4px;
        }
        .bz-age-sub {
          font-size: 13px; color: #888; font-weight: 500;
          margin: 0 0 20px;
          line-height: 1.5;
        }

        .bz-age-btns {
          display: flex; gap: 10px; width: 100%;
        }
        .bz-age-btn {
          flex: 1; height: 46px;
          border-radius: 14px; border: none;
          font-size: 15px; font-weight: 800;
          cursor: pointer; font-family: 'DM Sans', sans-serif;
          transition: opacity 0.15s, transform 0.12s;
          letter-spacing: -0.01em;
        }
        .bz-age-btn:hover  { opacity: 0.88; }
        .bz-age-btn:active { transform: scale(0.97); }

        .bz-age-btn-yes {
          background: ${GREEN}; color: ${ORANGE};
        }
        .bz-age-btn-no {
          background: transparent;
          border: 1.5px solid #d0ccc5 !important;
          color: #888;
        }
        .bz-age-btn-no:hover { border-color: #aaa !important; color: #555; }

        .bz-age-legal {
          font-size: 11px; color: #bbb;
          margin: 16px 0 0; line-height: 1.5;
        }
      `}</style>

      {/* Overlay */}
      <div className={`bz-age-overlay${visible ? ' visible' : ''}`} />

      {/* Card */}
      <div className={`bz-age-card${visible ? ' visible' : ''}`} role="dialog" aria-modal="true" aria-labelledby="age-title">

        {/* Banner topo */}
        <div className="bz-age-banner">
          {/* <div className="bz-age-logo">BOOZEN</div> */}
          <Image
            mx="auto"
            maxW={{ base: "110px", md: "90" }}
            maxH="100%"
            objectFit="contain"
            transition="all .25s ease"
            src={logoOrangeGreen}
          />
          <div className="bz-age-icon">🍺</div>
        </div>

        {/* Body */}
        <div className="bz-age-body">
          <p className="bz-age-title" id="age-title">Você tem 18 anos ou mais?</p>
          <p className="bz-age-sub">
            Este site vende bebidas alcoólicas.<br/>
            É proibida a venda para menores de 18 anos.
          </p>

          <div className="bz-age-btns">
            <button className="bz-age-btn bz-age-btn-yes" onClick={handleYesClick}>
              Sim, tenho 18+
            </button>
            <button className="bz-age-btn bz-age-btn-no" onClick={handleNoClick}>
              Não
            </button>
          </div>

          <p className="bz-age-legal">
            Ao entrar, você confirma ter idade legal para consumo de álcool<br />
            conforme a legislação vigente no Brasil.
          </p>
        </div>

      </div>
    </>
  );
}
